<template>
    <div>post data</div>
</template>

<script>
    import {AAuth} from "~/store/actions";
    import {MAuth} from "~/store/mutations";

    export default {
        name: "apple-auth",
        head: {
            title: 'Apple authentication | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                },
                {
                    hid: 'robots',
                    name: 'robots',
                    content: 'noindex'
                }
            ]
        },
        mounted() {
            this.$store.dispatch(AAuth.LOGIN_APPLE_USER, {
                code: this.$route.query.code,
                firstName: this.$route.query.appName,
                lastName: this.$route.query.appVer
            }).then((res) => {
                let token = res.access_token;
                localStorage.setItem('access_token', token);
                this.$store.commit(MAuth.SET_ACCESS_TOKEN, token);
                this.$gtm.push({event: "registration"});
                window.fbq('track', 'CompleteRegistration');
                window.uetq = window.uetq || [];
                window.uetq.push("event", "signup", {});
                this.$gtm.push({
                    'event': 'UETRegistration',
                    'ecomm_pagetype': 'conversion'
                });
                this.$router.push({path: 'my-account'});
            });
        }
    }
</script>

<style scoped>

</style>
